/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_HoldInputs */

const en_release_hold = /** @type {(inputs: Release_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Hold`)
};

const es_release_hold = /** @type {(inputs: Release_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberar apartado`)
};

/**
* | output |
* | --- |
* | "Release Hold" |
*
* @param {Release_HoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const release_hold = /** @type {((inputs?: Release_HoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_HoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_release_hold(inputs)
	return es_release_hold(inputs)
});